<template>
    <button
        class="btn relative btn-disabled-reset"
        :class="{ 'opacity-100': !!status }"
        :disabled="!!status"
        v-on="$listeners"
    >
        <div :class="{ invisible: !!status }">
            <slot></slot>
        </div>
        <div
            v-if="status === 'loading'"
            class="absolute inset-0 flex justify-center items-center"
        >
            <spinner class="spinner-sm" />
        </div>
        <div
            class="flex items-center bg-secondary text-white absolute inset-0 justify-center"
            v-if="status === 'success'"
        >
            <svg
                class="fill-current w-6 h-6 pointer-events-none"
                viewBox="0 0 20 20"
            >
                <path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
            </svg>
        </div>
    </button>
</template>

<script>
import spinner from '@/components/spinner.vue';
export default {
    components: { spinner },
    props: {
        status: { type: String }
    },
    watch: {
        async status(val) {
            if (val === 'success') {
                await new Promise(rs => setTimeout(rs, 1000));
                this.$emit('successShown');
            }
        }
    }
};
</script>
